"use client";
import React, { useEffect, useRef, useState } from "react";
import { useTranslations } from "next-intl";

const TeamAndFacilities = () => {
	const [isVisible, setIsVisible] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				const entry = entries[0];
				if (entry.isIntersecting) {
					setIsVisible(true);
					observer.disconnect(); // 动画触发后停止观察
				}
			},
			{
				root: null, // 使用浏览器视窗为根
				threshold: 0.07, // 当元素 10% 可见时触发
				rootMargin: "0px 0px -100px 0px", // 在元素离开视口100px前触发
			},
		);

		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => {
			if (ref.current) {
				observer.unobserve(ref.current);
			}
		};
	}, []);
	const t = useTranslations("about");
	return (
		<div className="container py-12">
			<div ref={ref} className="space-y-16">
				{/* Our Team Section */}
				<div className="flex flex-col items-center md:flex-row md:space-x-8">
					<div
						className={`w-full md:w-1/2 ${
							isVisible ? "animate__animated animate__fadeInLeft animate__delay-1s" : "opacity-0"
						}`}
					>
						<h2 className="text-3xl font-bold">{t("OurTeam")}</h2>
						<p className="mt-4">{t("team1")}</p>
						<p className="mt-4 font-bold text-blue-600">● {t("dataSupport")}</p>
						<p className="pl-4"> {t("t1")} </p>
						<p className="pl-4"> {t("t2")} </p>
						<p className="pl-4"> {t("t3")} </p>
						{/* <p
							dangerouslySetInnerHTML={{
								__html: t("experienceSummary", {
									20: `<span class="text-blue-600">20</span>`,
									100: `<span class="text-blue-600">100</span>`,
								}),
							}}
						></p> */}
					</div>
					<div
						className={`w-full md:w-1/2 ${
							isVisible ? "animate__animated animate__lightSpeedInRight animate__delay-2s" : "opacity-0"
						}`}
					>
						<img src="/image/about/Our Mission 01.jpg" alt="Our Team" className="rounded-lg shadow-lg" />
					</div>
				</div>

				{/* Our Facilities Section */}
				<div className="flex flex-col items-center md:flex-row md:space-x-8">
					<div
						className={`order-2 w-full md:order-1 md:w-1/2 ${
							isVisible ? "animate__animated animate__lightSpeedInLeft animate__delay-2s" : "opacity-0"
						}`}
					>
						<img src="/image/about/五轴加工 02.png" alt="Our Facilities" className="rounded-lg shadow-lg" />
					</div>
					<div
						className={`order-1 w-full md:order-2 md:w-1/2 ${
							isVisible ? "animate__animated animate__fadeInRight animate__delay-1s" : "opacity-0"
						}`}
					>
						<h2 className="text-3xl font-bold">{t("OurFacilities")}</h2>
						<p className="mt-4">{t("facilities1")}</p>
						<p className="mt-4 font-bold text-blue-600">● {t("Key Equipment")}</p>
						<p className="pl-4"> {t("k1")} </p>
						<p className="pl-4"> {t("k2")} </p>
						<p className="pl-4"> {t("k3")} </p>
						<p className="pl-4"> {t("k4")} </p>
						<p className="pl-4"> {t("k5")} </p>
					</div>
				</div>

				<div className="flex flex-col items-center md:flex-row md:space-x-8">
					<div
						className={`w-full md:w-1/2 ${
							isVisible ? "animate__animated animate__fadeInLeft animate__delay-1s" : "opacity-0"
						}`}
					>
						<h2 className="text-3xl font-bold">{t("Certifications and Quality Standards")}</h2>
						<p className="mt-4">{t("Quality is at")}</p>
						<p className="mt-4 font-bold text-blue-600">● {t("Certifications")}</p>
						<p className="pl-4"> {t("c1")} </p>
						<p className="pl-4"> {t("c2")} </p>
						<p className="pl-4"> {t("c3")} </p>
					</div>
					<div
						className={`w-full md:w-1/2 ${
							isVisible ? "animate__animated animate__lightSpeedInRight animate__delay-2s" : "opacity-0"
						}`}
					>
						<img
							src="/image/blog/Customer Testimonials.jpg"
							alt="Customer Testimonials"
							className="rounded-lg shadow-lg"
						/>
					</div>
				</div>

				<div className="flex flex-col items-center md:flex-row md:space-x-8">
					<div
						className={`order-2 w-full md:order-1 md:w-1/2 ${
							isVisible ? "animate__animated animate__lightSpeedInLeft animate__delay-2s" : "opacity-0"
						}`}
					>
						<img src="/image/about/kcxfz-1.jpg" alt="Our Facilities" className="rounded-lg shadow-lg" />
					</div>
					<div
						className={`order-1 w-full md:order-2 md:w-1/2 ${
							isVisible ? "animate__animated animate__fadeInRight animate__delay-1s" : "opacity-0"
						}`}
					>
						<h2 className="text-3xl font-bold">{t("Sustainability Initiatives")}</h2>
						<p className="mt-4">{t("JUSHENG is")}</p>
						<p className="mt-4 font-bold text-blue-600">● {t("Key Initiatives")}</p>
						<p className="pl-4"> {t("ki1")} </p>
						<p className="pl-4"> {t("ki2")} </p>
						<p className="pl-4"> {t("ki3")} </p>
					</div>
				</div>

				<div className="flex flex-col items-center md:flex-row md:space-x-8">
					<div
						className={`w-full md:w-1/2 ${
							isVisible ? "animate__animated animate__fadeInLeft animate__delay-1s" : "opacity-0"
						}`}
					>
						<h2 className="text-3xl font-bold">{t("Careers")}</h2>
						<p className="mt-4">{t("Join the")}</p>
						<p className="mt-4 font-bold text-blue-600">● {t("Available Positions")}</p>
						<p className="pl-4"> {t("ap1")} </p>
						<p className="pl-4"> {t("ap2")} </p>
						<p className="pl-4"> {t("ap3")} </p>
						<p className="pl-4"> {t("ap4")} </p>
						<p className="pl-4"> {t("ap5")} </p>
					</div>
					<div
						className={`w-full md:w-1/2 ${
							isVisible ? "animate__animated animate__lightSpeedInRight animate__delay-2s" : "opacity-0"
						}`}
					>
						<img
							src="/image/about/Our Mission 02.jpg"
							alt="Available Positions"
							className="rounded-lg shadow-lg"
						/>
					</div>
				</div>

				{/* Customer Testimonials Section */}
				{/* <div className="flex flex-col items-center md:flex-row md:space-x-8">
					<div
						className={`w-full md:w-1/2 ${
							isVisible ? "animate__animated animate__fadeInLeft animate__delay-1s" : "opacity-0"
						}`}
					>
						<h2 className="text-3xl font-bold">{t("Testimonials")}</h2>
						<p className="mt-4">{t("Testimonials1")}</p>
						<p className="mt-4">{t("Testimonials2")}</p>
						<p className="mt-4 font-bold text-blue-600">● {t("dataSupport")}</p>
						<p
							dangerouslySetInnerHTML={{
								__html: t("Testimonials3", {
									100: `<span class="text-blue-600">100</span>`,
									1000: `<span class="text-blue-600">1,000</span>`,
								}),
							}}
						></p>
					</div>
					<div
						className={`w-full md:w-1/2 ${
							isVisible ? "animate__animated animate__lightSpeedInRight animate__delay-2s" : "opacity-0"
						}`}
					>
						<img
							src="/image/blog/Customer Testimonials.jpg"
							alt="Customer Testimonials"
							className="rounded-lg shadow-lg"
						/>
					</div>
				</div> */}
			</div>
		</div>
	);
};

export default TeamAndFacilities;
